import React from "react";
import "./PageBanner.css";

/**
 * Photographic page banner: a clean photograph on the right that fades into
 * the page, and the page's own HTML copy in the open space on the left.
 * The image never carries text — everything readable is passed as children.
 * On narrow screens the photograph sits above the copy instead.
 *
 * @param {string} image     photograph from public/assets/banners
 * @param {string} imageAlt  description of the photograph
 * @param {string} [focus]   CSS object-position for the crop, e.g. "70% 30%"
 * @param {string} [labelledBy] id of the banner's heading, if it has one
 * @param {string} [variant] "wide" for a short, wide photograph (Contact)
 */
const PageBanner = ({
  image,
  imageAlt,
  focus = "center",
  labelledBy,
  ariaLabel,
  variant,
  children,
}) => (
  <section
    className={`page-banner ${variant ? `page-banner--${variant}` : ""}`}
    aria-labelledby={labelledBy}
    aria-label={labelledBy ? undefined : ariaLabel}
  >
    <div className="page-banner__media">
      <img src={image} alt={imageAlt} style={{ objectPosition: focus }} />
    </div>
    <div className="brand-col page-banner__inner">
      <div className="page-banner__copy">{children}</div>
    </div>
  </section>
);

export default PageBanner;
